<template>
  <v-content>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Bienvenido</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="ingresar()">
                <v-text-field
                  label="Usuario"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="formulario.usuario"
                  :error-messages="errorUsuario"
                  @input="$v.formulario.usuario.$touch()"
                  @blur="$v.formulario.usuario.$touch()"
                ></v-text-field>

                <v-text-field
                  label="Contraseña"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="formulario.password"
                  :error-messages="errorPass"
                  @input="$v.formulario.password.$touch()"
                  @blur="$v.formulario.password.$touch()"
                  @keydown.enter="ingresar()"
                ></v-text-field>
                <span class="error--text">{{ error }}</span>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="ingresar()"
                :loading="loadingFormulario"
                >Ingresar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import {mapActions} from "vuex"
export default {
  name: "Login",
  data() {
    return {
      formulario: {
        usuario: "",
        password: "",
      },
      error: "",
      loadingFormulario: false,
    };
  },
  methods: {
    ...mapActions(['iniciarSesion']),
    async ingresar() {
      this.$v.formulario.$touch();
      if (!this.$v.formulario.$invalid) {
        this.loadingFormulario = true;
        try {
          await this.iniciarSesion(this.formulario)
          this.$router.push(`/`);
        } catch (error) {
          console.log(error)
          this.error = "Error al iniciar sesion.";
        }
        this.loadingFormulario = false;
      }
    },
  },
  validations: {
    formulario: {
      usuario: { required, minLength: minLength(3) },
      password: { required, minLength: minLength(8) },
    },
  },
  computed: {
    errorUsuario() {
      const errors = [];
      if (!this.$v.formulario.usuario.$dirty) return errors;
      !this.$v.formulario.usuario.required &&
        errors.push("Debe ingresar un Usuario.");
      !this.$v.formulario.usuario.minLength &&
        errors.push("El Usuario debe tener como minimo 3 caracteres.");
      return errors;
    },
    errorPass() {
      const errors = [];
      if (!this.$v.formulario.usuario.$dirty) return errors;
      !this.$v.formulario.password.required &&
        errors.push("Debe ingresar una Contraseña.");
      !this.$v.formulario.password.minLength &&
        errors.push("La Contraseña debe tener como minimo 8 caracteres.");
      return errors;
    },
  },
};
</script>
